import { css } from 'styled-components';
const breakpointValues = {
    mobile: 49,
    notMobile: 49.05,
    landscape: 1024,
    notLandscape: 1025,
    portrait: 60,
    notPortrait: 60.5,
    tablet: 64,
    notTablet: 64.05,
};
const breakpointUnits = {
    mobile: 'em',
    notMobile: 'em',
    landscape: 'px',
    notLandscape: 'px',
    portrait: 'em',
    notPortrait: 'em',
    tablet: 'em',
    notTablet: 'em',
};
// TODO, this should be moved to the theme
export const breakpoints = {
    mobile: `${breakpointValues.mobile}${breakpointUnits.mobile}`,
    notMobile: `${breakpointValues.notMobile}${breakpointUnits.notMobile}`,
    landscape: `${breakpointValues.landscape}${breakpointUnits.landscape}`,
    notLandscape: `${breakpointValues.notLandscape}${breakpointUnits.notLandscape}`,
    portrait: `${breakpointValues.portrait}${breakpointUnits.portrait}`,
    notPortrait: `${breakpointValues.notPortrait}${breakpointUnits.notPortrait}`,
    tablet: `${breakpointValues.tablet}${breakpointUnits.tablet}`,
    notTablet: `${breakpointValues.notTablet}${breakpointUnits.notTablet}`,
};
const mediaQuery = (query) => (first, ...interpolations) => css `
        @media ${query} {
            ${css(first, ...interpolations)}
        }
    `;
const base = {
    atLeastLandscape: mediaQuery(`(min-width: ${breakpoints.landscape})`),
    mobile: mediaQuery(`(max-width: ${breakpoints.mobile})`),
    notMobile: mediaQuery(`(min-width: ${breakpoints.notMobile})`),
    portrait: mediaQuery(`(max-width: ${breakpoints.portrait})`),
    notPortrait: mediaQuery(`(min-width: ${breakpoints.notPortrait})`),
    tablet: mediaQuery(`(max-width: ${breakpoints.tablet})`),
    notTablet: mediaQuery(`(min-width: ${breakpoints.notTablet})`),
    landscape: mediaQuery(`(max-width: ${breakpoints.landscape})`),
    notLandscape: mediaQuery(`(min-width: ${breakpoints.notLandscape})`),
    print: mediaQuery('print'),
    mobileSideways: mediaQuery(`screen and (max-height: ${breakpointValues.mobile - 2}${breakpointUnits.mobile}) and (min-aspect-ratio: 4/3)`),
    nonStandardTablet: mediaQuery('(max-height: 560px)'),
};
/**
 * @deprecated Use app/styleguide/breakpoint-helpers.ts instead
 */
export const media = {
    ...base,
    multiple: (...args) => (props) => Object.keys(base).reduce((reduction, key) => {
        if (props[key]) {
            return css `
                        ${reduction} ${base[key](...args)}
                    `;
        }
        return reduction;
    }, ''),
};
/*
    Media query info: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/hover
    We've added this to be used when adding hover effects to components that we don't want to show up for touch devices.

    We've seen symptoms of clicks "bleeding through" resulting in stuck hover effects on underlying components on touch
    devices. By using this when added hover effects the intent is that they don't show up when using touch.
 */
export const addHover = (CSS) => {
    return css `
        @media (hover: hover) {
            ${CSS}
        }
    `;
};
